import React from "react";
import { StyleSheet, Text } from "react-native";

import UnlockUsersFreeTierBaseModal from "../Base/UnlockUsersFreeTierBaseModal";

import UnlockUsersPublicPhotosCard from "./Components/UnlockUsersPublicPhotosCard";
import UnlockUsersProfileDetailsCard from "./Components/UnlockUsersProfileDetailsCard";

import { themes } from "@/Components/Styling/themeConfigs";
import { Spacings } from "@/styling/spacings";
import { UserUnlockingStage } from "@/schemas/user/identity";
import {
  PROFILE_COMPLETION_TOTAL_SCORE,
  getUserProfileCompletionScore,
} from "@/utils/unlockingStage";
import { UserProfile } from "@/schemas/user/profile";

const currentTheme = themes.morning;

type Props = {
  userProfile: UserProfile;
  isModalVisible: boolean;
  onRequestClose: () => void;
  onRequestRefresh: () => void;
  isRefreshing: boolean;
};

function UnlockStageTwoModal({
  userProfile,
  isModalVisible,
  onRequestClose,
  onRequestRefresh,
  isRefreshing,
}: Props): React.JSX.Element {
  const progressBarInfoComponent: React.JSX.Element = (
    <Text style={[styles.infoText, styles.textBold]}>
      Complete steps below to unlock even more profiles
    </Text>
  );

  const taskCardsComponent: React.JSX.Element = (
    <>
      <UnlockUsersPublicPhotosCard
        userProfile={userProfile}
        onAction={onRequestClose}
      />
      <UnlockUsersProfileDetailsCard
        userProfile={userProfile}
        onAction={onRequestClose}
      />
    </>
  );

  return (
    <UnlockUsersFreeTierBaseModal
      title={`Unlock Even More Profiles`}
      subtitle={"📋 Just a few tasks to go!"}
      currentUnlockingStage={UserUnlockingStage.ON_STAGE_TWO}
      progressBarTitle="Profile Strength"
      earnedScore={getUserProfileCompletionScore(userProfile)}
      totalScore={PROFILE_COMPLETION_TOTAL_SCORE}
      progressBarInfoComponent={progressBarInfoComponent}
      taskCardsComponent={taskCardsComponent}
      isModalVisible={isModalVisible}
      onRequestClose={onRequestClose}
      onRequestRefresh={onRequestRefresh}
      isRefreshing={isRefreshing}
    />
  );
}

const styles = StyleSheet.create({
  infoText: {
    color: "#555",
    fontSize: currentTheme.typography.h3.size.mobile,
    marginBottom: Spacings.s1,
  },
  textBold: {
    fontWeight: "bold",
  },
});

export default UnlockStageTwoModal;
